import { withSearchParams } from 'api/utils/routes'
import { VenueDashboardTenderStatus } from 'generated/generated-graphql'
import { TabsTitles } from 'routes/Notifications/NotificationsTabsGroup'

export type ReturnToSearchParam = {
  returnTo?: string
}

export type OobCodeSearchParam = {
  oobCode?: string
}

export type ReturnToInvitationLink = {
  invitation?: string
}

export enum SignInErrorReason {
  UnitedKingdomVenueBlocked = 'united-kingdom-venue-blocked',
}

export type SignInErrorSearchParam = {
  errorReason?: SignInErrorReason
}

type FirebaseSignInSearchParam = {
  firebaseToken: string
}

export enum SubRoutes {
  EditDraft = 'edit-draft',
  CreateTender = 'create-tender',
}

export const Route = {
  FrontPage: () => `/`,
  SignIn: (
    searchParam?: ReturnToSearchParam &
      ReturnToInvitationLink &
      SignInErrorSearchParam
  ) => `/sign-in${withSearchParams(searchParam)}`,
  FirebaseSignIn: (searchParam?: FirebaseSignInSearchParam) =>
    `/firebase-sign-in${withSearchParams(searchParam)}`,
  SignUp: (searchParam?: ReturnToSearchParam) =>
    `/sign-up${withSearchParams(searchParam)}`,
  ForgotPassword: () => `/forgot-password`,
  BrandProfile: () => `/brand-profile`,
  VenueProfile: () => `/venue-profile`,
  ChooseYourCompany: (searchParam?: ReturnToSearchParam) =>
    `/choose-your-company${withSearchParams(searchParam)}`,
  EditBid: ({ id }: { id: number }) => `/bid-detail/${id}/edit`,
  TenderList: () => '/connect',
  ConnectPage: () => '/connect',
  MatchPage: () => '/match',
  CreateTender: (searchParams?: {
    tenderId?: number
    tenderDraftId?: number
  }) => `/${SubRoutes.CreateTender}${withSearchParams(searchParams)}`,
  Dashboard: (searchParams?: {
    filter?: VenueDashboardTenderStatus
    tab?: string
    openEnterpriseInfoModal?: boolean
  }) => `/dashboard${withSearchParams(searchParams)}`,
  EditTenderDraft: ({ id }: { id: number }) =>
    `/tender-detail/${id}/${SubRoutes.EditDraft}`,
  EditTender: ({
    id,
    searchParams,
  }: {
    id: number
    searchParams?: {
      activeStepIndex: number
    }
  }) => `/tender-detail/${id}/edit${withSearchParams(searchParams)}`,
  TenderDetail: ({ id }: { id: number }) => `/tender-detail/${id}`,
  CreateBid: ({ tenderId }: { tenderId: number }) =>
    `/tender-detail/${tenderId}/create-bid`,
  BrandLandingPage: () => '/',
  VenueLandingPage: () => '/',
  VenueBillingData: () => '/venue-billing-data',
  BrandBillingData: () => '/brand-billing-data',
  ProductPortfolio: () => '/product-portfolio',
  VatNumber: () => '/vat',
  VenueNotificationSettings: () => `/venue-notification-settings`,
  BrandNotificationSettings: () => `/brand-notification-settings`,
  TenderPreferences: () => '/tender-preferences',
  ChangeEmail: () => '/change-email',
  UserData: (searchParams?: { emailToChangeToken: string }) =>
    `/user-data${withSearchParams(searchParams)}`,
  UserContactDetails: () => '/user-contact-details',
  Notifications: (searchParams?: { tab: TabsTitles }) =>
    `/notifications${withSearchParams(searchParams)}`,
  BrandSubscriptionOverview: (searchParams?: {
    enterpriseToken?: string
    openEnterpriseInfoModal?: boolean
  }) => `/brand-subscription-overview${withSearchParams(searchParams)}`,
  BrandPlanSelection: () => `/plan-selection`,
  BrandInvoices: () => '/brand-invoices',
  CreateMatchBid: () => '/match/create',
  BidDetail: ({
    id,
    searchParams,
  }: {
    id: number
    searchParams?: { openMessageModal?: boolean }
  }) => `/bid/${id}${withSearchParams(searchParams)}`,
  EditMatchBid: ({ id }: { id: number }) => `/match/${id}/edit`,
  CompanyMembers: () => '/company-members',
  Integrations: () => '/integrations',
  VerifyEmail: (searchParams?: { oobCode?: string }) =>
    `/verify-email${withSearchParams(searchParams)}`,
}

export const ExternalUrls = {
  termsAndServiceBrand: 'https://eztenda.com/terms-of-service-brands',
  termsAndServiceVenue: 'https://eztenda.com/terms-of-service-venues',
  privacyPolicy: 'https://eztenda.com/privacy-policy',
  cookiePolicy: 'https://eztenda.com/cookie-policy',
}
